import { render, staticRenderFns } from "./GoBack.vue?vue&type=template&id=08ae3f3e&scoped=true"
import script from "./GoBack.vue?vue&type=script&lang=js"
export * from "./GoBack.vue?vue&type=script&lang=js"
import style0 from "./GoBack.vue?vue&type=style&index=0&id=08ae3f3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ae3f3e",
  null
  
)

export default component.exports